import useToastContext from 'hooks/useToastContext';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';


const UnitDetail = () => {
  const location = useLocation();
  const { t } = useTranslation();

  const [item] = useState(location?.state?.item);


  const panelTitle = {
    fontSize: '18px',
    paddingTop: '10px',
    paddingBottom: '10px',
    texAlign: 'left',
    fontWeight: 600,
  };
  const body = {
    padding: '10px',
    backgroundColor: '#fff',
    marginLeft: '20px',
    marginRight: '20px',
    borderWidth: '1px',
    borderRadius: '4px',
  };
  const subTitle = {
    fontSize: '14px',
    color: '#76838f',
  };

  return (
    <div className="page-content read container-fluid">
      <div className="row">
        <div className="col-md-12">
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t('PROJECT')}</h1>
            <p style={subTitle}>{item?.projectTitle}</p>
          </div>

          <div className="body" style={body}>
            <h1 style={panelTitle}>{t('PROPERTY_TYPE')}</h1>
            <p style={subTitle}>{item?.unitType}</p>
          </div>

          <div className="body" style={body}>
            <h1 style={panelTitle}> {t('O_NUMBER')}</h1>
            <p style={subTitle}>{item?.unitNumber}</p>
          </div>

          <div className="body" style={body}>
            <h1 style={panelTitle}>{t('O_SLUG')}</h1>
            <p style={subTitle}>{item?.slug}</p>
          </div>

          <div className="body" style={body}>
            <h1 style={panelTitle}>{t('O_SLUG') + t('O_ARABIC')}</h1>
            <p style={subTitle}>{item?.slugAr}</p>
          </div>

          <div className="body" style={body}>
            <h1 style={panelTitle}>{t('O_FLOOR')}</h1>
            <p style={subTitle}>{item?.floor}</p>
          </div>

          <div className="body" style={body}>
            <h1 style={panelTitle}>{t('O_BLOCK_NAME')}</h1>
            <p style={subTitle}>{item?.blockName}</p>
          </div>

          <div className="body" style={body}>
            <h1 style={panelTitle}>{t('O_TOTAL_AREA')}</h1>
            <p style={subTitle}>{item?.totalArea}</p>
          </div>

          <div className="body" style={body}>
            <h1 style={panelTitle}>{t('O_PRICE')}</h1>
            <p style={subTitle}>{item?.cost}</p>
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t('PROPERTY_TAX')}</h1>
            <p style={subTitle}>{item?.propertyTax || 'N/A'}</p>
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t('PROPERTY_TAX_PER')}</h1>
            <p style={subTitle}>{item?.propertyTaxPercentage || 'N/A'}</p>
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t('COMMISSION')}</h1>
            <p style={subTitle}>{item?.commission || 'N/A'}</p>
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t('COMMISSION_PER')}</h1>
            <p style={subTitle}>{item?.commissionPercentage || 'N/A'}</p>
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t('COMMISSION_TAX')}</h1>
            <p style={subTitle}>{item?.commissionTax || 'N/A'}</p>
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t('COMMISSION_TAX_PER')}</h1>
            <p style={subTitle}>{item?.commissionTaxPercentage || 'N/A'}</p>
          </div>

          <div className="body" style={body}>
            <h1 style={panelTitle}>{t('O_BEDROOM')}</h1>
            <p style={subTitle}>{item?.bedroom}</p>
          </div>

          <div className="body" style={body}>
            <h1 style={panelTitle}>{t('O_BATHROOM')}</h1>
            <p style={subTitle}>{item?.bathroom}</p>
          </div>

          <div className="body" style={body}>
            <h1 style={panelTitle}>{t('O_PLAN')}</h1>
            {item?.plan?.map((img, index) => {
              return (
                <div
                  style={{
                    width: '100px',
                    height: '100px',
                    borderWidth: '1px',
                    display: 'inline-block',
                    marginRight: '10px',
                  }}
                >
                  <img id={index} src={img} alt="unitImage" />
                </div>
              );
            })}
          </div>

          {/* <div className="body" style={body}>
            <h1 style={panelTitle}>{t("O_RATINA_PLAN")}</h1>
            {item?.ratinaPlan?.map((img, index) => {
              return (
                <div
                  style={{
                    width: "100px",
                    height: "100px",
                    borderWidth: "1px",
                    display: "inline-block",
                    marginRight: "10px",
                  }}
                >
                  <img id={index} src={img}  alt="unitImage" />
                </div>
              );
            })}
          </div> */}

          <div className="body" style={body}>
            <h1 style={panelTitle}>{t('O_IMAGE')}</h1>
            {item?.image?.map((img, index) => {
              return (
                <div
                  style={{
                    width: '100px',
                    height: '100px',
                    borderWidth: '1px',
                    display: 'inline-block',
                    marginRight: '10px',
                  }}
                >
                  <img id={index} src={img} alt="unitImage" />
                </div>
              );
            })}
          </div>

          {/* <div className="body" style={body}>
            <h1 style={panelTitle}>{t("O_VR")}</h1>
            {item?.vrImage?.map((img, index) => {
              return (
                <div
                  style={{
                    width: "100px",
                    height: "100px",
                    borderWidth: "1px",
                    display: "inline-block",
                    marginRight: "10px",
                  }}
                >
                  <img id={index} src={img}  alt="unitImage" />
                </div>
              );
            })}
          </div> */}

          <div className="body" style={body}>
            <h1 style={panelTitle}>{t('O_YOUTUBE_URL')}</h1>
            <p style={subTitle}>{item?.youtubeUrl}</p>
          </div>

          {/* <div className="body" style={body}>
            <h1 style={panelTitle}>{t("O_RATINA_IMAGE")}</h1>
            {item?.ratinaImage?.map((img, index) => {
              return (
                <div
                  style={{
                    width: "100px",
                    height: "100px",
                    borderWidth: "1px",
                    display: "inline-block",
                    marginRight: "10px",
                  }}
                >
                  <img id={index} src={img}  alt="unitImage" />
                </div>
              );
            })}
          </div> */}

          <div className="body" style={body}>
            <h1 style={panelTitle}>{t('O_PARKING_SPACE')}</h1>
            <p style={subTitle}>{item?.parkingSpace}</p>
          </div>

          <div className="body" style={body}>
            <h1 style={panelTitle}>{t('O_PVT_UTILITY_SPACE')}</h1>
            <p style={subTitle}>{item?.utilitySpace}</p>
          </div>

          <div className="body" style={body}>
            <h1 style={panelTitle}>{t('O_BUILT_AREA')}</h1>
            <p style={subTitle}>{item?.builtArea}</p>
          </div>

          <div className="body" style={body}>
            <h1 style={panelTitle}>{t('O_UNIT_AREA_OWNER')}</h1>
            <p style={subTitle}>{item?.unitAreaOwnership}</p>
          </div>

          <div className="body" style={body}>
            <h1 style={panelTitle}>{t('O_UNIT_PER_OWNER')}</h1>
            <p style={subTitle}>{item?.percentUnitAreaOwner}</p>
          </div>

          <div className="body" style={body}>
            <h1 style={panelTitle}>{t('O_COMPONENT')}</h1>
            {item?.component?.map((res) => {
              return <p style={subTitle}>{res}</p>;
            })}
          </div>

          <div className="body" style={body}>
            <h1 style={panelTitle}>{t('O_COMPONENT_AR')}</h1>
            {item?.componentAr?.map((res) => {
              return <p style={subTitle}>{res}</p>;
            })}
          </div>

          {/* <div className="body" style={body}>
            <h1 style={panelTitle}>{t('O_INTERIOR')}</h1>
           {item?.interior?.map((img, index) => {
              return (
                <div
                  style={{
                    width: "100px",
                    height: "100px",
                    borderWidth: "1px",
                    display: "inline-block",
                    marginRight: "10px",
                  }}
                >
                  <img id={index} src={img}  alt="unitImage" />
                </div>
              );
            })}
          </div> */}

          {/* <div className="body" style={body}>
            <h1 style={panelTitle}>{t("O_RATINA_INTERIOR")}</h1>
           {item?.ratinaInterior?.map((img, index) => {
              return (
                <div
                  style={{
                    width: "100px",
                    height: "100px",
                    borderWidth: "1px",
                    display: "inline-block",
                    marginRight: "10px",
                  }}
                >
                  <img id={index} src={img}  alt="unitImage" />
                </div>
              );
            })}
          </div> */}

          <div className="body" style={body}>
            <h1 style={panelTitle}>{t('META_DESCRIPTION')}</h1>
            <p style={subTitle}>{item?.metaDescription}</p>
          </div>

          <div className="body" style={body}>
            <h1 style={panelTitle}> {t('META_DESCRIPTION') + t('O_ARABIC')}</h1>
            <p style={subTitle}>{item?.metaDescriptionAr}</p>
          </div>

          <div className="body" style={body}>
            <h1 style={panelTitle}>{t('META_KEYWORDS')}</h1>
            <p style={subTitle}>{item?.metaKeywords}</p>
          </div>

          <div className="body" style={body}>
            <h1 style={panelTitle}> {t('META_KEYWORDS') + t('O_ARABIC')}</h1>
            <p style={subTitle}>{item?.metaKeywordsAr}</p>
          </div>

          <div className="body" style={body}>
            <h1 style={panelTitle}>{t('IS_MAIN')}</h1>
            <p style={subTitle}>{item?.isMain}</p>
          </div>

          <div className="body" style={body}>
            <h1 style={panelTitle}>{t('IS_OFFER')}</h1>
            <p style={subTitle}>{item?.isSpecialOffer}</p>
          </div>

          <div className="body" style={body}>
            <h1 style={panelTitle}>{t('O_STATUS')}</h1>
            <p style={subTitle}>{item?.status}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnitDetail;
